export default "__VITE_ASSET__DtwbWrqi__"